import * as Yup from 'yup';
import { emailSchema, phoneSchema } from '@/utils/validation';

const validationSchema = Yup.object().shape({
	isExistingRelationshipContact: Yup.boolean(),
	existingRelationshipContact: Yup.mixed().when('isExistingRelationshipContact', {
		is: (isExisting) => isExisting,
		then: () => Yup.mixed().required('Select a contact'),
		otherwise: () => Yup.mixed().nullable(),
	}),
	firstName: Yup.string().when('isExistingRelationshipContact', {
		is: (isExisting) => !isExisting,
		then: () => Yup.string().trim().required('First name is required.'),
		otherwise: () => Yup.string(),
	}),
	lastName: Yup.string(),
	email: Yup.string().when('isExistingRelationshipContact', {
		is: (isExisting) => !isExisting,
		then: () => emailSchema(true, undefined, 'Email'),
		otherwise: () => emailSchema(false, undefined, 'Email'),
	}),
	relationshipType: Yup.string().when('isExistingRelationshipContact', {
		is: (isExisting) => !isExisting,
		then: () => Yup.string().required('Type is required'),
		otherwise: () => Yup.string(),
	}),
	relationshipStatus: Yup.string().when('isExistingRelationshipContact', {
		is: (isExisting) => !isExisting,
		then: () => Yup.string().required('Status is required'),
		otherwise: () => Yup.string(),
	}),
	relationshipCompanyName: Yup.string().trim(),
	relationshipCompanyId: Yup.string().when('isExistingRelationshipContact', {
		is: (isExisting) => isExisting,
		then: () => Yup.string().required('Company is required'),
		otherwise: () => Yup.string(),
	}),
	roleTitle: Yup.string(),
	mobile: phoneSchema(),
	notesSummary: Yup.string(),
	nextActionDescription: Yup.string(),
	lastContactedAt: Yup.string().nullable(),
	nextActionDate: Yup.string().nullable(),
	isPrimary: Yup.boolean(),
});

export default validationSchema;
